import React from 'react'
import styled from 'styled-components'

import { TEXT_STYLES } from 'TEXT_STYLES'
import { PLAN_DETAILS } from 'constants/plan_details'

const Wrapper = styled.div`
  min-width: 222px;
  display: flex;
  flex-direction: column-reverse;
  flex: auto;
  align-items: center;
  padding: 12px 0;
`
const Details = styled.div`
  width: 100%;
  div:nth-child(even) {
    background-color: ${props => props.theme.colors.coolGrey025};
  }
`
const Row = styled.div`
  ${TEXT_STYLES.BodyBlack}
  font-weight: 500 !important;
  height: 26px;
  display: flex;
  align-items: center;
  border-radius: 4px;
`

export const PlanFeatures = () => {
  return (
    <Wrapper>
      <Details>
        {Object.keys(PLAN_DETAILS).map((feature, index) => {
          return <Row key={index}>{feature}</Row>
        })}
      </Details>
    </Wrapper>
  )
}
